module.exports = "/_next/static/images/game-header-race-03f8d4ca914e62d41e3497ae35eeadf4.png";